import { Injectable } from '@angular/core';
import { DesktopUserDataService } from './desktop-user-data.service';

@Injectable()
export class DesktopNotesDataService {

    constructor(
        private desktopUserDataService: DesktopUserDataService
    ){
    }

    /**
     * Set full ebooks note for a user to the DB
     * @param notesData : {uid, ebookCode, data}
     * @param uid : userId
     * @param ebookCode : ebookCode
     * @param data : notes data as fetched from server
     * @returns 
     */
    setBulkNotes(notesData){
        notesData.userDataType = this.desktopUserDataService.USER_DATA_TYPES.NOTE;
        return this.desktopUserDataService.setBulkRecords(notesData);    
    }

    /**
     * method to update a note
     * @param noteUpdateData {uid, ebookCode, data}
     * @returns 
     */
    updateNote(noteUpdateData){
        noteUpdateData.userDataType = this.desktopUserDataService.USER_DATA_TYPES.NOTE;
        return this.desktopUserDataService.updateRecord(noteUpdateData); 
    }

    /**
     * method to get note(s) of an ebook for a user
     * @param params : {uid, ebookCode, documentId?}
     */
    getNotes(params){
        params.userDataType = this.desktopUserDataService.USER_DATA_TYPES.NOTE;
        return this.desktopUserDataService.getRecords(params); 
    }


    /**
     * method to delete note(s) of an ebook for a user
     * @param params : {uid, ebookCode, documentId?}
     * @param uid : userId
     * @param ebookCode : ebookCode
     * @param documentId : if given, only one note will be deleted.
     * If no documentId is passed then all the notes will be deleted
     */
     deleteNotes(params){
        params.userDataType = this.desktopUserDataService.USER_DATA_TYPES.NOTE;
        return this.desktopUserDataService.deleteRecords(params); 
    }
    
}